<script lang="ts" setup>
import { ref } from 'vue';
import { useWindowScroll } from '@vueuse/core'
import PageMenu from './PageMenu.vue';
import { getRegistrationUrl } from '../utils/registration';

const { y } = useWindowScroll();
const hamburgerActive = ref(false);
</script>

<template>
  <header>
    <div class="header-area header-style-one header-light" :class="{ 'sticky': y >= 20 }">
      <div class="container">
        <div class="row">
          <!-- eslint-disable-next-line unocss/order -->
          <div class="col-lg-12 align-items-center d-xl-flex col-xl-2 col-md-12 col-sm-12 col-xs-12">
            <!-- eslint-disable-next-line unocss/order -->
            <div class="align-items-center d-flex logo justify-content-between">
              <RouterLink to="/" class="logo-dark">
                <!-- <img src="../assets/images/logo.png" alt="logo" class="h-56 w-171 object-contain"> -->
                <div class="h-56 w-171 object-contain"></div>
              </RouterLink>
              <RouterLink to="/" class="logo-white">
                <!-- <img src="../assets/images/logo-v2.png" alt="logo" class="h-56 w-171 object-contain"> -->
                <div class="h-56 w-171 object-contain"></div>
              </RouterLink>

              <div class="d-flex mobile-menu">

                <a href="javascript:;" class="d-block d-xl-none hamburger" :class="{ 'h-active': hamburgerActive }" @click="hamburgerActive = !hamburgerActive">
                  <span class="h-top"></span>
                  <span class="h-middle"></span>
                  <span class="h-bottom"></span>
                </a>

              </div>
            </div>
          </div>

          <PageMenu v-model:hamburger="hamburgerActive" />

          <div class="col-xl-2 d-none d-xl-block col-2 p-0">
            <div class="d-flex align-items-center nav-right justify-content-end h-100">
              <ul>
                <li class="nav-btn">
                  <a class="primary-btn-fill" :href="getRegistrationUrl()" target="_blank">报名</a>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
</style>
